import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('pricing-pages-ui');